import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;
`;

export const Panel = styled.div`
  position: fixed;
  top: 50%;
  right: 24px;
  transform: translateY(-50%);
  z-index: 1000;
  width: 240px;
  max-height: 480px;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.backgrounds.dashboardWidget};
  border: solid 1px ${({ theme }) => theme.borders.dashboard};
  box-shadow: 0 4px 24px 0 ${({ theme }) => theme.shadows.dashboard};
  border-radius: 6px;
  overflow: hidden;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 12px;
  border-bottom: solid 1px ${({ theme }) => theme.borders.dashboard};
  flex-shrink: 0;
`;

export const PanelTitle = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.dashboardTitle};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  color: ${({ theme }) => theme.text.dashboardLightText};
  font-size: 16px;
  line-height: 1;

  &:hover {
    color: ${({ theme }) => theme.text.dashboardTitle};
  }
`;

export const WidgetList = styled.div`
  overflow-y: auto;
  flex: 1;
  padding: 8px 0;
`;

export const EmptyMessage = styled.div`
  padding: 20px 16px;
  font-size: 12px;
  color: ${({ theme }) => theme.text.dashboardLightText};
  text-align: center;
`;

export const WidgetItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  cursor: pointer;
  transition: background 0.1s;

  &:hover {
    background: ${({ theme }) => theme.borders.dashboard}22;
  }
`;

export const WidgetItemLabel = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.text.dashboardDarkText};
`;

export const AddButton = styled.button`
  background: none;
  border: solid 1px ${({ theme }) => theme.borders.dashboard};
  border-radius: 4px;
  cursor: pointer;
  color: ${({ theme }) => theme.text.dashboardLightText};
  font-size: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  flex-shrink: 0;

  &:hover {
    border-color: ${({ theme }) => theme.borders.workspaceSelectedItem};
    color: ${({ theme }) => theme.borders.workspaceSelectedItem};
  }
`;
